import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CommunicationFilterService } from '../../services/communication/communication-filter/communication-filter.service';
import { CommunicationListenerService } from '../../services/communication/communication-listen/communication-listen.service';
import { ObservableDictionary } from '../ObservableDictionary';

export abstract class BaseCommunicationService<T> {
  protected readonly communicationListenerService = inject(
    CommunicationListenerService,
  );
  protected readonly communicationFilterService = inject(
    CommunicationFilterService,
  );

  protected readonly KEY_SPLIT = '/';

  protected abstract readonly dictionary: ObservableDictionary<T>;

  abstract getOrAddItem(key: string): Observable<T>;
}
